require('./index.css')

$(document).on('click', 'a[data-vid]', function (e) {
  var vid = $(this).data('vid');
  _qblog.wsd.click('GREATEXPECTATIONS.RECOMMEND');
  _qblog.wsd.click('GREATEXPECTATIONS.' + vid);
});

// 获取视频片单信息
function getVideosInfo() {
  var vidArr = [100325571, 100324235, 100324155, 100324103, 100323686];

  var list = '';
  for (var i = 0; i < vidArr.length; i++) {
    //请求接口http://video.browser.qq.com/api/get_video_info?video_id=
    jQuery.ajax({
      url: "http://video.browser.qq.com/api/get_video_info",
      type: 'get',
      // async: false,
      data: {
        video_id: vidArr[i]
      },
      success: function (res) {
        var dataNum = res.videoBasic.setNum[0];
        // type == 4 综艺
        if (res.videoBasic.type == 4) {
          list = '更新至' + dataNum.updateSetNum + '集';
        } else {
          if (dataNum.totalSetNum == dataNum.updateSetNum) {
            list = '全' + dataNum.totalSetNum + '集';
          } else {
            list = '更新至' + dataNum.updateSetNum + '集';
          }
        }
        $('.videos .' + res.videoBasic.videoId).html(list);
      }
    });
  }
}

getVideosInfo()



// WEBPACK FOOTER //
// ./modules/video_recommend/index.js